import React from "react";
import { Tabs, Tab, Box, Card, CardContent } from "@mui/material";

import { useStickyTab } from "../../../utils/uiPrefs";
import BlenderFlowDashboard from "./BlenderFlowDashboard";
import Lam2RollsDashboard from "../Lamination2/Lam2RollsDashboard";
import Lam1ExtruderDashboard from "./Lam1ExtruderDashboard";

interface TabPanelProps {
  children?: React.ReactNode;
  value: number;
  index: number;
}

const TabPanel: React.FC<TabPanelProps> = ({ children, value, index }) => {
  return (
    <div role="tabpanel" hidden={value !== index} style={{ width: "100%" }}>
      {value === index && <Box sx={{ pt: { xs: 1, md: 2 } }}>{children}</Box>}
    </div>
  );
};

const Lam1ProductionTabs: React.FC = () => {
  // Key is versioned: the tab order changed, so stored indices from the old
  // order would restore the wrong tab.
  const [tab, setTab] = useStickyTab("lam1.v2", 3);

  const handleChange = (_: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

  return (
    <Card sx={{ m: { xs: 1, md: 2 } }}>
      <CardContent sx={{ p: { xs: 1, md: 2 } }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={tab}
            onChange={handleChange}
            aria-label="Lamination 1 production tabs"
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
          >
            <Tab
              label="Rolls"
              sx={{ minWidth: "auto", px: { xs: 1, md: 2 } }}
            />
            <Tab
              label="Extruders"
              sx={{ minWidth: "auto", px: { xs: 1, md: 2 } }}
            />
            <Tab
              label="Blenders"
              sx={{ minWidth: "auto", px: { xs: 1, md: 2 } }}
            />
          </Tabs>
        </Box>

        <TabPanel value={tab} index={0}>
          {/* Same page as Lam 2's Rolls tab; blurred until Lam 1 has roll data. */}
          <Lam2RollsDashboard line="lam1" />
        </TabPanel>

        <TabPanel value={tab} index={1}>
          <Lam1ExtruderDashboard />
        </TabPanel>

        <TabPanel value={tab} index={2}>
          <BlenderFlowDashboard
            blenderOptions={[
              { id: "1", label: "Blender A", hasFlow3: true },
              { id: "2", label: "Blender B", hasFlow3: false },
            ]}
          />
        </TabPanel>
      </CardContent>
    </Card>
  );
};

export default Lam1ProductionTabs;
